import { jsx as s } from "react/jsx-runtime";
import { useRef as f, useState as D, useCallback as u, useEffect as l } from "react";
import { DROPDOWN_OPENED_BODY_ATTR as w } from "../../styles/variables.js";
import { DropdownContext as x } from "./context.js";
import { useDropdownContext as g } from "./context.js";
import { DropdownWrapperContainer as O } from "./style.js";
function P({
  className: c,
  children: i,
  onClose: o,
  onOpen: t
}) {
  const m = f(null), [r, e] = D(!1), a = u(() => {
    e(!0);
  }, []), d = u(() => {
    document.body.removeAttribute(w), e(!1);
  }, []), n = f(r);
  return l(() => {
    const p = n.current;
    if (n.current = r, t && r && !p) {
      t();
      return;
    }
    o && !r && p && o();
  }, [r, t, o]), /* @__PURE__ */ s(
    x.Provider,
    {
      value: {
        isOpen: r,
        openDropdown: a,
        closeDropdown: d,
        triggerRef: m
      },
      children: /* @__PURE__ */ s(O, { className: c, children: i })
    }
  );
}
export {
  x as DropdownContext,
  P as DropdownContextWrapper,
  g as useDropdownContext
};
